const API_BASE_URL = process.env.REACT_APP_API_URL;

export const WESHIP_API_URL = process.env.REACT_APP_WESHIP_API_URL;
export const WESHIP_API_KEY = process.env.REACT_APP_WESHIP_API_KEY;

export default API_BASE_URL;

export const APP_VERSION = process.env.REACT_APP_VERSION || 'dev';
